var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IconLinkItem',{key:"user",attrs:{"id":"refresh_button","text":"Refresh","icon":"mdi-refresh"},on:{"click":_vm.refreshEvaluations}},[_vm._v(" Refresh ")])
}
var staticRenderFns = []

export { render, staticRenderFns }